<template>
  <div style="width: 100%; height: 100%">
    <iframe
      :src="iframeUrl"
      frameborder="0"
      width="100%"
      height="100%"
      allowtransparency
      v-show="imgShow"
    ></iframe>
    <img v-if="switchhost == 'true'" :src="xiaomaolvHello" />
    <img v-if="switchhost == 'false'" :src="duoduoHello" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      switchhost: "",
      iframeUrl: "",
      main: "",
      imgShow: true,
      xiaomaolvHello: require("../../static/imgs/xiaomaolvhello.png"),
      duoduoHello: require("../../static/imgs/duoduohello.png"),
    };
  },
  methods: {
    getpage() {
      
      console.log(JSON.parse(localStorage.getItem("total_userinfo")).userid);
      var id = JSON.parse(localStorage.getItem("total_userinfo")).userid;
      this.$opsaxios
        .post(
          "/api/v1/member/agent/metabase/" +
            parseInt(JSON.parse(localStorage.getItem("total_Global")).main),
          {
            dashboardId: parseInt(
              JSON.parse(localStorage.getItem("total_Global")).main
            ),
            params: `{}`,
          }
        )
        .then((res) => {
          if (res.data.code == 0) {

            this.iframeUrl = res.data.data + "#bordered=false&titled=true";
          } else {
            this.imgShow = false;
          }
        });
    },
  },
  created() {
    this.getpage();
  },
  mounted() {
    this.switchhost = localStorage.getItem("total_switchhost");
    this.main = JSON.parse(localStorage.getItem("total_Global")).main;
  },
};
</script>
<style scoped>
.dialog_s .el-select-dropdown__item {
  padding-left: 15px !important;
}
img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue